module.exports = __webpack_public_path__ + "img/gouwu.b8131f17.png";